export default "__VITE_ASSET__C6ELIckT__"